export const lastPart = (uri) => {
  const split = uri.split(/\/|#/);
  return split.pop();
};
